var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"header-logo",attrs:{"href":"https://spaceswap.app/"}},[_c('img',{attrs:{"alt":"SpaceSwap","src":require(`@/assets/img/${_vm.chainName}/small-logo.svg`)}}),(_vm.$route.name === 'home')?_c('img',{staticClass:"new-year",attrs:{"alt":"bells","src":require(`@/assets/img/new-year/_logo.svg`)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }